import { Colors } from '../../themes/colors';

export const DashboardIcon = ({ color = Colors.neutral_600 }) => (
  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.16663 5.83332C5.16663 5.18899 5.68896 4.66666 6.33329 4.66666H22.6666C23.311 4.66666 23.8333 5.18899 23.8333 5.83332V8.16666C23.8333 8.81099 23.311 9.33332 22.6666 9.33332H6.33329C5.68896 9.33332 5.16663 8.81099 5.16663 8.16666V5.83332Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16663 15.1667C5.16663 14.5223 5.68896 14 6.33329 14H13.3333C13.9776 14 14.5 14.5223 14.5 15.1667V22.1667C14.5 22.811 13.9776 23.3333 13.3333 23.3333H6.33329C5.68896 23.3333 5.16663 22.811 5.16663 22.1667V15.1667Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1666 15.1667C19.1666 14.5223 19.689 14 20.3333 14H22.6666C23.311 14 23.8333 14.5223 23.8333 15.1667V22.1667C23.8333 22.811 23.311 23.3333 22.6666 23.3333H20.3333C19.689 23.3333 19.1666 22.811 19.1666 22.1667V15.1667Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
